import React, { useEffect } from 'react';
import { AssetUrls } from 'config/assets';
import { SEOHelmet } from 'components/SEO';
import './MaintenancePage.css';

const MaintenancePage: React.FC = () => {
  // Set page title
  useEffect(() => {
    document.title = '503 - Under Maintenance | TradeMagic.gg';
  }, []);

  // Thoughtseize's scryfall ID (Theros printing - iconic maintenance-themed card)
  const thoughtseizeScryfallId = '318d6c46-6890-4b1e-8bc6-8e8f7f5e7b27';
  const backgroundImage = AssetUrls.cards.getCardImage(thoughtseizeScryfallId, 'art_crop');

  const socialLinks = [
    {
      name: 'Twitter',
      url: 'https://x.com/trademagic_gg',
      icon: AssetUrls.icons.social.twitter,
    },
    {
      name: 'Bluesky',
      url: 'https://bsky.app/profile/trademagic.bsky.social',
      icon: AssetUrls.icons.social.bluesky,
    },
    {
      name: 'Reddit',
      url: 'https://www.reddit.com/r/TradeMagic',
      icon: AssetUrls.icons.social.reddit,
    },
  ];

  return (
    <div className="maintenance-container">
      <SEOHelmet
        title="503 - Under Maintenance - TradeMagic"
        description="TradeMagic is currently under maintenance. We'll be back shortly. Thanks for your patience!"
        canonical="https://trademagic.gg/maintenance"
      />

      {/* Blurred Background */}
      <div
        className="maintenance-bg"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'blur(110px)'
        }}
      />

      {/* Content */}
      <div className="maintenance-content">
        {/* Mana Symbols: 5-0-3 */}
        <div className="maintenance-mana-symbols">
          <img
            src="https://trademagic-assets.s3.us-west-1.amazonaws.com/symbols/mana/5.svg"
            alt="Five mana"
            className="mana-symbol"
          />
          <img
            src="https://trademagic-assets.s3.us-west-1.amazonaws.com/symbols/mana/0.svg"
            alt="Zero mana"
            className="mana-symbol"
          />
          <img
            src="https://trademagic-assets.s3.us-west-1.amazonaws.com/symbols/mana/3.svg"
            alt="Three mana"
            className="mana-symbol"
          />
        </div>

        {/* Message */}
        <h1 className="maintenance-title">We're performing some maintenance.</h1>
        <p className="maintenance-subtitle">We'll be back shortly. Thanks for your patience!</p>

        {/* Icon - wrench/tools visual */}
        <div className="maintenance-icon">
          ⚙️
        </div>

        {/* Social Media Links */}
        <div className="maintenance-social">
          <p className="maintenance-social-text">Follow us for updates:</p>
          <div className="maintenance-social-icons">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="maintenance-social-link"
                aria-label={`Follow us on ${social.name}`}
              >
                <img
                  src={social.icon}
                  alt={social.name}
                  className="maintenance-social-icon"
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
